<template>
  <div class="fc-notification-feature-cell" :data-testid="dataTestid">
    <span class="fc-notification-feature-cell__row">
      <v-icon x-small class="fc-notification-feature-cell__icon">{{ icon }}</v-icon>
      <span>{{ label }}</span>
    </span>
    <div v-if="summary" class="fc-notification-feature-cell__sub">{{ summary }}</div>
  </div>
</template>

<script>
import { NOTIFICATION_FEATURE_ICON, NOTIFICATION_FEATURE_LABEL } from '../../../utils/constants';
import { notificationTypeSummary } from '../../../utils/notificationNameUtils';

export default {
  name: 'NotificationFeatureCell',
  props: {
    item: { type: Object, default: () => ({}) },
    dataTestid: { type: String, default: 'notification-feature-cell' },
  },
  computed: {
    label() {
      return NOTIFICATION_FEATURE_LABEL[this.item.feature] || this.item.feature || '—';
    },
    icon() {
      return NOTIFICATION_FEATURE_ICON[this.item.feature] || 'mdi-bell-outline';
    },
    summary() {
      return notificationTypeSummary(this.item);
    },
  },
};
</script>
